import React from "react";
import logo from "../../../assets/images/logo.png";

function MemberLoginLogoArea(props) {
  return (
    <>
      <div className="logoTop">
        <img src={logo} alt="" />
        <h5>Welcome to Member Login</h5>
      </div>
    </>
  );
}

export default MemberLoginLogoArea;
